import * as React from 'react';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';

export default function AlertDialog({
    title = null,
    component,
    confirmLabelButton = 'Ok',
    cancelLabelButton = 'Cancelar',
    fullWidth = true,
    handleConfirm = null,
    showCancelButton = false,
    showConfirmButton= false,
    handleClose = () => { }
}) {
    // const [open, setOpen] = React.useState(false);

    const handleClickConfirm = () => {
        handleClose()
        handleConfirm()
    }

    const handleClickCancel = () => {
        handleClose()
    }

    return (
        <Dialog
            open={true}
            onClose={handleClickCancel}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
            fullWidth={true}
            maxWidth='xl'
        >
            {title &&
                <DialogTitle id="alert-dialog-title">
                    {title}
                </DialogTitle>
            }
            <DialogContent>
                <DialogContentText id="alert-dialog-description">
                    {component}
                </DialogContentText>
            </DialogContent>
            <DialogActions>
                {showCancelButton && <Button onClick={handleClickCancel}>{cancelLabelButton}</Button>}
                {showConfirmButton && <Button onClick={handleClickConfirm} autoFocus>{confirmLabelButton}</Button>}
            </DialogActions>
        </Dialog>
    );
}